import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Brand } from './Brand';

export function AppFooter() {
  const { t } = useTranslation();
  return (
    <footer className="app-footer">
      <div className="content-wrap footer-inner">
        <div>
          <Brand linked={false} />
          <p className="footer-copy">{t('app.privacyPromise')}<br />{t('app.localProcessing')}</p>
        </div>
        <nav className="footer-links" aria-label={t('navigation.about')}>
          <Link to="/settings/privacy">{t('navigation.privacy')}</Link>
          <Link to="/settings/offline-storage">{t('navigation.offline')}</Link>
          <Link to="/settings/about">{t('navigation.about')}</Link>
        </nav>
      </div>
    </footer>
  );
}
